const validateColor = color => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(color);

export default {
  name: 'MContentLoader',
  props: {
    rtl: {
      default: false,
      type: Boolean,
    },
    speed: {
      default: 2,
      type: Number,
    },
    width: {
      default: 400,
      type: Number,
    },
    height: {
      default: 130,
      type: Number,
    },
    primary: {
      type: String,
      default: '#E2E8F0',
      validator: validateColor,
    },
    secondary: {
      type: String,
      default: '#CBD5E0',
      validator: validateColor,
    },
  },
  computed: {
    viewbox() {
      return `0 0 ${this.width} ${this.height}`;
    },
    formatedSpeed() {
      return `${this.speed}s`;
    },
    gradientId() {
      return `gradient-${this.uid}`;
    },
    clipPathId() {
      return `clipPath-${this.uid}`;
    },
    svg() {
      if (this.rtl) {
        return {
          transform: 'rotateY(180deg)',
        };
      }
      return {};
    },
    rect() {
      return {
        style: {
          fill: `url(#${this.gradientId})`,
        },
        clipPath: `url(#${this.clipPathId})`,
      };
    },
  },
  data: () => ({
    uid: null,
  }),
};
